import React from "react";
import HomeInitialSection from "./Sections/HomeInitial/HomeInitialSection";
import OfferingSection from "./Sections/Offerings/OfferingSection";
import FounderMessageSection from "./Sections/FounderMessage/FounderMessageSection";
import WorkSection from "./Sections/Work/WorkSection";
import TestimonialsSection from "./Sections/Testimonials/TestimonialsSection";
import Banner from "../../Components/Banner";
import Footer from "../../Components/Footer";
import { motion } from "framer-motion";
import Header from "../../Components/Header";
import AnnouncementBanner from "../../Components/AnnouncementBanner";

const QUERYOSITY_URL =
  "https://queryosity.xyz/?utm_source=datapixl&utm_medium=banner&utm_campaign=homepage";

const HomePage = () => {
  return (
    <motion.div
      className="flex flex-col"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <AnnouncementBanner
        ariaLabel="Queryosity announcement"
        closeLabel="Dismiss Queryosity announcement"
        storageKey="queryosity-banner-dismissed"
        href={QUERYOSITY_URL}
        ctaText="Get your free report"
        message={
          <>
            New from Datapixl:{" "}
            <span className="font-bold text-link-hovered">Queryosity</span>.
            See how your brand shows up in ChatGPT, Perplexity and Gemini.
          </>
        }
      />
      <div className="block md:hidden sticky top-0 z-50 bg-app-background">
        <Header />
      </div>
      <HomeInitialSection />
      <OfferingSection />
      <FounderMessageSection />
      <WorkSection />
      <TestimonialsSection />
      <Banner title="Shape the Future with Al" subtitle="Let's Talk!" />
      <Footer />
    </motion.div>
  );
};

export default HomePage;
